import {
  Autocomplete,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import HeaderNavigation from "../../../../../Componants/Common/header Navigation/HeaderNavigation";
import CommonButton from "../../../../../Componants/Common/Button";
import DynamicTabs from "../../../../../components/DynamicTabs";
import { Calendar } from "../../../../../Componants/Common/Calender";
import {
  fetchBrandList,
  fetchEngineerPartConsumption,
  getSparePartByModelDropdown,
  exportEngineerPartConsumption,
} from "../../../../../API Service/apiService";
import Loader from "../../../../../Componants/Loader/Loader";
import toast, { Toaster } from "react-hot-toast";
import { format } from "date-fns";
import Paginate from "../../../../../Componants/Common/Paginate";
import ExportToExcel from "../../../../../Componants/Common/ExportToExcel";
import { formatDate, formatDateForPayload } from "../../../../../utils/dateFormatter";
import { downloadFile } from "../../../../../utils/downloadHelper";


const dateTypes = [{ label: "Creation",id:1 }];
// export to excel cols
const cells = [
  "Brand ",
  "Category",
  "Sub Category",
  "Model",
  "Part Name",
  "Part Code",
  "State",
  "City",
  "Jobsheet No.",
  "Consupmtion Date",
  "Quantity",
];
// table cells visible on UI
const tableCells = [
  "Part Name",
  "Part Code",
  "Jobsheet No.",
  "Consupmtion Date",
  "Quantity",
  "WarrantyStatus"
];
const rows = [
  {
    jobNumber: "J001",
    jobDate: "10/02/2022",
    model: "Car Model",
    creationDate: "10/02/2022",
    closureDate: "15/02/2022",
    repairAction: "Completed",
  },
];
const JobReport = () => {
  const [loading, setLoading] = useState(false);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [brandList, setBrandList] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState(null);
  const [selectedDateType, setSelectedDateType] = useState(null);
  const [page, setPage] = useState(1);
  const [dataSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [tableData, setTableData] = useState([]);
  const [partList, setPartList] = useState([]);
  const [selectedPart, setSelectedPart] = useState(null);

  const [searchParams, setSearchParams] = useState({
    type: "",
    startDate: "",
    endDate: "",
    limit: 10,
    page: 1,
    brandId: "",
    partId: "",
  });

  const handleDateChange = (fieldName, date, formattedDate) => {
    if (fieldName === "fromDate") {
      const payloadDate = formatDateForPayload(date);
      setFromDate(date);
      setSearchParams((prev) => ({ ...prev, startDate: payloadDate }));
    } else if (fieldName === "toDate") {
      if (fromDate && date < fromDate) {
        toast.error("To Date cannot be less than From Date");
        return;
      }
      const payloadDate = formatDateForPayload(date);
      setToDate(date);
      setSearchParams((prev) => ({ ...prev, endDate: payloadDate }));
    }
  };

  const fetchTableData = async (params = searchParams) => {
    try {
      setLoading(true);
      const response = await fetchEngineerPartConsumption(params);
      console.log(response);
      if (response?.data) {
        setTableData(response.data.consumptionRecords || []);
        setTotalRecords(response.data.pagination.totalRecords || 0);
      } else {
        toast.error(response.message);
        console.log(response);
        setTableData([]);
        setTotalRecords(0);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error(error.response.data.message);
      setTableData([]);
      setTotalRecords(0);
    } finally {
      setLoading(false);
    }
  };

  // Fetch initial data
  const fetchBrandListData = async () => {
    try {
      setLoading(true);
      const brandResponse = await fetchBrandList();
      setBrandList(brandResponse.data.brandList || []);
    } catch (error) {
      console.error("Error fetching initial data:", error);
      toast.error("Failed to fetch initial data");
    } finally {
      setLoading(false);
    }
  };

  const fetchPartDetailsData = async (brandId = "") => {
    try {
      const partResponse = await getSparePartByModelDropdown({ brandId });
      if (partResponse.status === "success") {
        setPartList(partResponse.data || []);
      } else {
        setPartList([]);
      }
    } catch (error) {
      console.error("Error fetching part details:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = () => {
    const updatedParams = {
      ...searchParams,
      page: 1,
      limit: dataSize,
    };
    setSearchParams(updatedParams);
    fetchTableData(updatedParams);
  };

  const handleReset = () => {
    // Reset all form states
    setFromDate(null);
    setToDate(null);
    setSelectedBrand(null);
    setSelectedDateType(null);
    setSelectedPart(null);
    setPage(1);
    
    // Reset search params to initial state
    const resetParams = {
      type: "",
      startDate: "",
      endDate: "",
      limit: 10,
      page: 1,
      brandId: "",
      partId: ""
    };
    
    setSearchParams(resetParams);
    
    // Reset table data
    setTableData([]);
    setTotalRecords(0);
    
    // Fetch fresh data with reset params
    fetchTableData(resetParams);
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
    const updatedParams = { ...searchParams, page: newPage };
    setSearchParams(updatedParams);
    fetchTableData(updatedParams);
  };

  const handleExportToExcel = async () => {
    try {
      setLoading(true);
      const updatedParams = {
        ...searchParams,
        page: -1,
        limit: -1,
      };
      const response = await exportEngineerPartConsumption(updatedParams);
      if (response?.status === "success" && response?.data?.filePath) {
        downloadFile(response.data.filePath);
        toast.success("File downloaded successfully");
      } else {
        throw new Error("Invalid response from server");
      }
    } catch (error) {
      console.error("Error exporting engineer part consumption:", error);
      toast.error(error?.response?.data?.message || error.message || "Export failed");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBrandListData();
    fetchTableData();
  }, []);

  useEffect(() => {
    if(selectedBrand?._id){
    const brandId = selectedBrand?._id;
    fetchPartDetailsData(brandId);
    }
  }, [selectedBrand]);

  return (
    <Grid container>
      {loading && <Loader />}
      <Toaster position="top-center" reverseOrder={false} />
      <HeaderNavigation value={"Part Consumption Report"} />
      <DynamicTabs />
      <Grid
        container
        gap={5}
        sx={{
          background: "#F5F8FF",
          margin: "10px 10px ",
          width: "100%",
          borderRadius: "5px",
          padding: "12px",
          fontWeight: 600,
        }}
      >
        <Grid item>
          <Autocomplete
            options={dateTypes}
            getOptionLabel={(option) => option.label}
            value={selectedDateType}
            onChange={(event, value) => {
              setSelectedDateType(value);
              setSearchParams((prev) => ({
                ...prev,
                type: value ? value.id : "",
              }));
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Date Type"
                variant="standard"
                style={{ width: "12rem" }}
              />
            )}
          />
        </Grid>
        <Grid item>
          <Calendar
            value={fromDate}
            handleChange={handleDateChange}
            fieldName="fromDate"
            label="From Date"
          />
        </Grid>
        <Grid item>
          <Calendar
            value={toDate}
            handleChange={handleDateChange}
            fieldName="toDate"
            label="To Date"
          />
        </Grid>

        <Grid container gap={5}>
          <Grid item>
            <Autocomplete
              options={brandList}
              getOptionLabel={(option) => option.brandName || ""}
              value={selectedBrand}
              onChange={(event, value) => {
                setSelectedBrand(value);
                setSelectedPart(null);
                setSearchParams((prev) => ({
                  ...prev,
                  brandId: value?._id || "",
                  partId: "",
                }));
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Brand"
                  variant="standard"
                  style={{ width: "12rem" }}
                />
              )}
            />
          </Grid>

          <Grid item>
            <Autocomplete
              options={partList}
              getOptionLabel={(option) => option.sparePartCode || ""}
              value={selectedPart}
              onChange={(event, value) => {
                setSelectedPart(value);
                setSearchParams((prev) => ({
                  ...prev,
                  partId: value?._id || "",
                }));
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Part Code"
                  variant="standard"
                  style={{ width: "12rem" }}
                />
              )}
            />
          </Grid>
          <Grid item>
            <Autocomplete
              options={partList}
              getOptionLabel={(option) => option.sparePartName || ""}
              value={selectedPart}
              onChange={(event, value) => {
                setSelectedPart(value);
                setSearchParams((prev) => ({
                  ...prev,
                  partId: value?._id || "",
                }));
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Part Name"
                  variant="standard"
                  style={{ width: "12rem" }}
                />
              )}
            />
          </Grid>
        </Grid>
        <CommonButton name={"Search"} handleOnClick={handleSearch} />
        <CommonButton name={"Cancel"} handleOnClick={handleReset} />
      </Grid>

      <Grid
        container
        sx={{
          background: "#F5F8FF",
          margin: "0 10px ",
          width: "100%",
          borderRadius: "5px",
          padding: "12px",
          fontWeight: 600,
        }}
      >
        <Grid
          container
          sx={{ width: "100%", display: "flex", justifyContent: "flex-end", mb: 1 }}
        >
          <ExportToExcel onClick={handleExportToExcel} />
        </Grid>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} size="small" aria-label="simple table">
            <TableHead>
              <TableRow>
                {tableCells.map((cell, index) => (
                  <TableCell
                    key={index}
                    sx={{ color: "white", textAlign: "center" }}
                  >
                    {cell}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {tableData.length > 0 ? (
                tableData.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell align="center">{row.partName || "-"}</TableCell>
                    <TableCell align="center">{row.partCode || "-"}</TableCell>
                    <TableCell align="center">{row.jobSheetNo || "-"}</TableCell>
                    <TableCell align="center">
                      {row.consumptionDate ? formatDate(row.consumptionDate) : "-"}
                    </TableCell>
                    <TableCell align="center">{row.quantity || "-"}</TableCell>
                    <TableCell align="center">{row.warrantyStatus || "-"}</TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={tableCells.length} align="center">
                    No Data Available
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <Grid
          container
          sx={{
            marginTop: "1rem",
            marginBottom: "1rem",
            width: "100%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Paginate
            page={page}
            totalRecords={totalRecords}
            onPageChange={handlePageChange}
            dataSize={dataSize}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default JobReport;
